

class CartManager extends HTMLElement {
  constructor() {
    super();

    this.endpoints = {
      change: '/cart/change.js',
      update: '/cart/update.js',
      cart: '/cart.js',
    };

    this.headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    this.miniCartSelector = this.getAttribute('mini-cart-selector') || '#cart-drawer';
    this.miniCartSectionId = this.getAttribute('mini-cart-section-id') || 'carpet-cart-drawer';
    this.headerSectionId = this.getAttribute('header-section-id') || 'header';

    this.isProcessing = false;
  }

  connectedCallback() {
    this.bindMiniCartEvents();
      this.bindOutsideClickToClose();

  }

  disconnectedCallback() {
    const drawer = document.querySelector(this.miniCartSelector);
    if (drawer) drawer.dataset.bound = '0';
  }


  bindOutsideClickToClose() {
  document.addEventListener('click', (e) => {
    const drawer = document.querySelector(this.miniCartSelector);
    if (!drawer) return;

    if (!drawer.classList.contains('show')) return;

    if (drawer.contains(e.target)) return;

    if (e.target.closest('[data-bs-dismiss]')) return;

    const instance = bootstrap.Offcanvas.getInstance(drawer);
    instance?.hide();
  });
}


  async request(url, method = 'GET', body = null) {
    try {
      const res = await fetch(url, {
        method,
        headers: this.headers,
        body: body ? JSON.stringify(body) : null,
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
      return await res.json();
    } catch (err) {
      console.error('[CartManager] Request failed:', err);
      throw err;
    }
  }

  async getCart() {
    return await this.request(this.endpoints.cart);
  }

  async updateLineItem(line, quantity) {
    const updatedCart = await this.request(this.endpoints.change, 'POST', { line, quantity });
    this.dispatchEvent(new CustomEvent('cart:update', { detail: updatedCart }));
    await Promise.all([this.renderMiniCart({ keepOpen: true }), this.updateCartIconBubble(updatedCart)]);
    return updatedCart;
  }

  async removeLineItem(line) {
    return await this.updateLineItem(line, 0);
  }

  async updateCartAttributes(attributes = {}, note = null) {
    const payload = { attributes, note };
    const updatedCart = await this.request(this.endpoints.update, 'POST', payload);
    this.dispatchEvent(new CustomEvent('cart:update', { detail: updatedCart }));
    await Promise.all([this.renderMiniCart({ keepOpen: true }), this.updateCartIconBubble(updatedCart)]);
    return updatedCart;
  }

  updateCartIconBubbleSimple(qty) {
    const countEl = document.querySelector('#cart-icon-bubble .cartCount');
    const headerCounter = document.getElementById('headerCount');
    if (countEl) {
      if (qty > 0) {
        countEl.textContent = qty;
        if (headerCounter) headerCounter.innerHTML = `(${qty})`;
        countEl.classList.remove('d-none');
      } else {
        countEl.classList.add('d-none');
        headerCounter.innerHTML = '(0)';
      }
    }
  }

  async updateCartIconBubble(cartData = null) {
    try {
      if (cartData && typeof cartData.item_count !== 'undefined') {
        this.updateCartIconBubbleSimple(cartData.item_count);
        return;
      }

      const url = `/?section_id=${this.headerSectionId}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Failed to fetch header section`);
      const html = await res.text();

      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newBubble = tmp.querySelector('#cart-icon-bubble');
      const oldBubble = document.querySelector('#cart-icon-bubble');
      if (newBubble && oldBubble) oldBubble.outerHTML = newBubble.outerHTML;
    } catch (err) {
      console.warn('[CartManager] Failed to update cart bubble:', err);
    }
  }

  async renderMiniCart({ keepOpen = true } = {}) {
    try {
      const url = `/cart?section_id=${this.miniCartSectionId}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Failed to fetch section ${this.miniCartSectionId}`);
      const html = await res.text();

      const container = document.querySelector(this.miniCartSelector);
      if (!container) return;

      const wasOpen = container.classList.contains('show');
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newDrawer = tmp.querySelector(this.miniCartSelector);
      if (!newDrawer) return;

      const curBody = container.querySelector('.offcanvas-body');
      const newBody = newDrawer.querySelector('.offcanvas-body');

      if (curBody && newBody) curBody.innerHTML = newBody.innerHTML;

      this.bindMiniCartEvents();
      if (keepOpen && !wasOpen) this.openMiniCart();

      await this.updateCartIconBubble();
    } catch (err) {
      console.error('[CartManager] renderMiniCart failed:', err);
    }
  }

openMiniCart() {
  const container = document.querySelector(this.miniCartSelector);
  if (!container) return;

  if (window.bootstrap?.Offcanvas) {
    const instance = bootstrap.Offcanvas.getOrCreateInstance(container, {
      backdrop: true,
      scroll: false,
      keyboard: true,
    });

    instance.show();
  } else {
    container.classList.add('is-open');
  }
}



  bindMiniCartEvents() {
    const drawer = document.querySelector(this.miniCartSelector);
    if (!drawer || drawer.dataset.bound === '1') return;
    drawer.dataset.bound = '1';

    drawer.addEventListener('click', async (e) => {
      const minus = e.target.closest('.cart-minus');
      const plus = e.target.closest('.cart-add');
      const remove = e.target.closest('.remove-cart-item');

      if (minus || plus) {
        e.preventDefault();
        const item = e.target.closest('.cart-item');
        if (!item) return;
        const line = this.getLineFromItem(item, drawer);
        const input = item.querySelector('.cart-prd-amount-in');
        if (!line || !input) return;

        const currentQty = parseInt(input.value || '0', 10);
        const delta = plus ? 1 : -1;
        const nextQty = Math.max(0, currentQty + delta);

        input.disabled = true;
        try {
          await this.updateLineItem(line, nextQty);
        } finally {
          input.disabled = false;
        }
        return;
      }

      if (remove) {
        e.preventDefault();
        const item = e.target.closest('.cart-item');
        const line = this.getLineFromItem(item, drawer);
        if (!line) return;
        remove.disabled = true;
        try {
          await this.removeLineItem(line);
        } finally {
          remove.disabled = false;
        }
      }
    });

    drawer.addEventListener('change', async (e) => {
      const input = e.target.closest('.cart-prd-amount-in');
      if (!input) return;

      const item = e.target.closest('.cart-item');
      const line = this.getLineFromItem(item, drawer);
      if (!line) return;

      let qty = parseInt(input.value || '0', 10);
      qty = isNaN(qty) ? 0 : Math.max(0, qty);

      input.disabled = true;
      try {
        await this.updateLineItem(line, qty);
      } finally {
        input.disabled = false;
      }
    });
  }

  getLineFromItem(itemEl, scope) {
    let line = parseInt(itemEl?.dataset?.line || '0', 10);
    if (!line) {
      const items = Array.from(scope.querySelectorAll('.cart-item'));
      const idx = items.indexOf(itemEl);
      line = idx >= 0 ? idx + 1 : 0;
    }
    return line;
  }
}

customElements.define('cart-manager', CartManager);


document.addEventListener('DOMContentLoaded', () => {
  const instance = document.querySelector('cart-manager');
  if (instance) {
    window.CartManagerInstance = instance;
  }
});